import React from 'react'

import { Link } from "react-router-dom";
import SrLyncy from "../images/Sr. lyncy.jpg";

import ScrollToTop from "react-scroll-to-top";
import Header from '../inc/Header';

function SisterLyncy() {
    return (
        <div>
            <Header />
            <br />
            <br />
            <br />
            <br />
           
            <ScrollToTop smooth top="100" color="light"/>
            <div className='bestberhamporeschool'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Sister Lincy<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg> </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="album py-2">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 mt-3">
                            <div className="card">
                                <img src={SrLyncy} className="card-img-top" alt="SrLyncy"/>

                            </div>
                        </div>
                        <div className="col-md-8 mt-3">


                            <div className="card-body">
                                <h5 className='mb-2'><b>Dear Alumni, ( MISAA )</b></h5>
                                <p>Warm greetings to each one of you!</p>
                                <h6 className="card-title textjustify mb-3">Our school has given us not only an education but also lifelong friendships, cherished memories, and values that continue to guide us. As alumni, you remain an important part of this wonderful family. Though the years may have taken you to different places and professions, you will always remain an important part of our school community. our school will always remain the place where our dreams began and lifelong friendships were formed. 


                                </h6>
                                <h6 className='textjustify mb-3'>As members of our beloved school family, you continue to be a source of pride and inspiration.. Your achievements, values, and contributions reflect the education and spirit nurtured within these walls. We are grateful for your continued love, support, and connection with your alma mater. We look forward to your active participation in our alumni activities and hope that together we can inspire and guide future generations of students.
                                </h6>
                                <h6 className='textjustify mb-3'>Let us stay connected, support one another, and work together to give back to our alma mater whenever possible. May our bond grow stronger with each passing year, and may we continue to inspire the next generation of students. </h6>

                                <h6>Wishing you and your families good health, happiness, and success. Looking forward to meeting you all and creating many more beautiful memories together.</h6>
                                
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />


        </div>
    )
}

export default SisterLyncy